import axios from "axios";
import Vue from "vue";

export default class BillsAction {

    constructor() {

    }


    static download(billId) {

        Vue.$toast.warning("Aguarde... Estamos preparando seu boleto.", {
            position: "top-right",
            duration: 5000,
        });
        axios
            .get(`${process.env.API_PBM}/boletos/download?boleto_id[]=${billId}`, {
                responseType: "blob",
            })

        .then((response) => {
                let fileURL = window.URL.createObjectURL(new Blob([response.data]));

                let fileLink = document.createElement("a");

                fileLink.href = fileURL;

                fileLink.setAttribute(
                    "download",
                    `boleto_${new Date().toLocaleString()}.pdf`
                );

                document.body.appendChild(fileLink);

                fileLink.click();
            })
            .catch((error) => {
                Vue.$toast.error("Ops! Não foi possível completar a ação.", {
                    position: "top-right",
                    duration: 5000,
                });
            });

    }

    static async getCodeBills(billId) {

        Vue.$toast.warning("Aguarde...", {
            position: "top-right",
            duration: 5000,
        });
        return await axios
            .get(`${process.env.API_PBM}/boletos/codigoBarras?boleto_id=${billId}`)

        .then((response) => {
            return response.data.data.documento_linha_digitavel;

        })

        .catch((error) => {
            Vue.$toast.error("Ops! Não foi possível completar a ação.", {
                position: "top-right",
                duration: 5000,
            });
        });
    }
    static copyCodeBills(billId) {

        Vue.$toast.warning("Aguarde...", {
            position: "top-right",
            duration: 5000,
        });
        axios
            .get(`${process.env.API_PBM}/boletos/codigoBarras?boleto_id=${billId}`)

        .then((response) => {
            let copyCode = response.data.data.documento_linha_digitavel;
            this.copy(copyCode);

        })

        .catch((error) => {
            Vue.$toast.error("Ops! Não foi possível completar a ação.", {
                position: "top-right",
                duration: 5000,
            });
        });
    }

    static async copy(text) {
        // alert(document.execCommand('copy'));
        navigator.clipboard.writeText(text).then(() => {
            Vue.$toast.success("Copiado com sucesso!", {
                position: "top-right",
                duration: 5000,
            });
        }).catch(() => {
            Vue.$toast.error("Ops! Não foi possível completar a ação.", {
                position: "top-right",
                duration: 5000,
            });
        })

    }

    static downloadAttachedDocument(billId) {
        axios
            .get(`${process.env.API_PBM}/boletos/downloadDocuments?boleto_id=${billId}`, {
                responseType: "blob",
            })

        .then((response) => {
                let fileURL = window.URL.createObjectURL(new Blob([response.data]));

                let fileLink = document.createElement("a");

                fileLink.href = fileURL;

                fileLink.setAttribute(
                    "download",
                    `documento_${new Date().toLocaleString()}.pdf`
                );
                document.body.appendChild(fileLink);

                fileLink.click();
            })
            .catch(() => {
                Vue.$toast.error("Ops! Não foi possível completar a ação.", {
                    position: "top-right",
                    duration: 5000,
                });
            });
    }

    static async getPix(billId) {
        return await axios
            .get(`${process.env.API_PBM}/pix/boleto/${billId}`)

        .then((response) => {
                response.data.data["cod_id"] = billId;
                return response.data.data;
            })
            .catch((error) => {
                return Promise.reject(error);
            });
    }

}


// WEBPACK FOOTER //
// ./src/views/components/home/bill/BillsAction.js